export default {
  name: "Other Supporting Documentation",
  prefix: "G",
  sections: [
    {
      name: "Type of Employer",
      fields: [
        {
          isGroup: {
            code: "G.1",
            machine_name: "empType",
            label: "Choose only one *",
            tooltip: "Enter the type of employer application.",
            coloring: "none",
            type: "radio",
            fields: [
              {
                widget: "radio",
                choice: "Individual Employer",
                value: "Individual Employer",
                validate: ["required"],
                clearSchema: [
                  "apdxdLegalName",
                  "apdxdTradeName",
                  "apdxdEmpAddr1",
                  "apdxdEmpAddr2",
                  "apdxdEmpCity",
                  "apdxdEmpState",
                  "apdxdEmpPostcode",
                  "apdxdEmpCountry",
                  "apdxdEmpProvince",
                  "apdxdEmpPhone",
                  "apdxdEmpPhoneext",
                  "apdxdEmpFein",
                  "apdxdEmpNaics",
                  "apdxdEmpNaicsDescription",
                  "apdxdPocLastname",
                  "apdxdPocFirstname",
                  "apdxdPocMiddlename",
                  "apdxdPocJobtitle",
                  "apdxdPocAddr1",
                  "apdxdPocAddr2",
                  "apdxdPocCity",
                  "apdxdPocState",
                  "apdxdPocPostcode",
                  "apdxdPocCountry",
                  "apdxdPocProvince",
                  "apdxdPocPhone",
                  "apdxdPocPhoneext",
                  "apdxdPocEmail",
                ],
                clearFiles: ["empIsContractAttached", "declareConfmEmp"],
              },
              {
                widget: "radio",
                choice: "Joint Employer (e.g., Job Contractor)",
                value: "Joint Employer (e.g., Job Contractor)",
                validate: ["required"],
                // clearSchema: [
                //   "acwiaHigherEdu",
                //   "acwiaAffiliated",
                //   "acwiaNonprofit",
                //   "coveredByAcwiaFiles",
                //   "acwiaStatusChange",
                // ],
                // clearFiles: ["coveredByAcwiaFiles"],
              },
            ],
          },
        },
      ],
    },
    {
      name: "Employer's MSPA Certificate of Registration",
      fields: [
        {
          isGroup: {
            code: "G.2",
            machine_name: "empMspaAttached",
            label: `Is a copy of the employer's current Migrant and Seasonal Agricultural Workers Protection Act (MSPA) 
              Certificate of Registration identifying the farm labor contracting activities the employer is authorized 
              to perform attached to this application? *`,
            tooltip: `Where an employer is obligated to obtain a Certificate of Registration under the MSPA, it must submit a copy 
              of its valid Certificate of Registration with the H-2B Application for Temporary Employment Certification. 
              Check the appropriate box indicating whether or not an MSPA Certificate of Registration is attached to the 
              application. Select “N/A” if the employer is not covered by the requirements of the MSPA to obtain a Certificate 
              of Registration.`,
            coloring: "none",
            type: "radio",
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "No",
                value: "NO",
                validate: ["required"],
                clearFiles: ["g2_mspa_attached"],
              },
              {
                widget: "radio",
                choice: "N/A",
                value: "N/A",
                validate: ["required"],
                clearFiles: ["g2_mspa_attached"],
              },
            ],
          },
        },
        {
          isGroup: {
            code: "G.2",
            machine_name: "g2_mspa_attached",
            label: `You can upload a copy of the employer's current MSPA Certificate of Registration identifying the farm labor contracting activities the employer is authorized to perform attached to this application.`,
            tooltip:
              "Submit a copy of employer's valid Certificate of Registration with the H-2B Application for Temporary Employment Certification.",
            coloring: "none",
            fields: [
              {
                label: "Uploaded MSPA Attachment",
                labelHidden: true,
                machine_name: "g2_mspa_attached",
                name: "Employer MSPA",
                widget: "file_upload",
                choice: "Yes",
                value: "YES",
                fileTypes: [".pdf", ".doc", ".docx", ".txt", ".xls", ".xlsx"],
                validate: ["required", "checkValue"],
              },
            ],
            isVisible: {
              when: "empMspaAttached",
              is: "YES",
            },
          },
        },
        {
          code: "G.2",
          widget: "alert",
          isVisible: {
            when: "empMspaAttached",
            is: "NO",
            hideStyles: true,
          },
          description: `
          Note: This is required to issue your certification and may result in delays in processing`,
          type: "none",
          coloring: "none",
        },
        /**
         * ! Field G.3 DOES NOT exist on the front end. HOWEVER, it does exist on the paper form / PDF
         * ! so the field below can not have a code of G.3.
         *
         * ! Additionally, when G.1 is selected as JOINT, data cleaner on the backend has code to select
         * ! the 'G.3 machine name' as YES.
         */
        {
          isGroup: {
            machine_name: "externalOtherDocPreface",
            name: "Document Upload - Job Contractor Agreement/Contract",
            label: "Are you a Job Contractor as defined by 20 CFR 655.5? *",
            // tooltip: `Where an employer is obligated to obtain a Certificate of Registration under the MSPA, it must submit
            // a copy of its valid Certificate of Registration with the H-2B Application for Temporary Employment Certification.
            // Check the appropriate box indicating whether or not an MSPA Certificate of Registration is attached to the application.
            // Select “N/A” if the employer is not covered by the requirements of the MSPA to obtain a Certificate of Registration.`,
            coloring: "none",
            type: "radio",
            isVisible: {
              when: "empType",
              is: "Joint Employer (e.g., Job Contractor)",
            },
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "No",
                value: "NO",
                validate: ["required"],
                clearSchema: ["empIsContractAttached"],
                clearFiles: ["empIsContractAttached"],
              },
            ],
          },
        },
        {
          isGroup: {
            code: "G.4",
            machine_name: "empIsContractAttached",
            label: `Because this application relates to a Job Contractor, an executed contract or other agreement between the 
            job contractor and the employer-client establishing a bona fide relationship to the workers sought under this 
            application must be uploaded. §`,
            tooltip: `Upload an executed contract or other agreement which exists between the job contractor and the 
            employer-client (the joint employers) that establishes the relationship between the joint employers and the 
            workers sought under this application.`,
            coloring: "none",
            isVisible: {
              when: "externalOtherDocPreface",
              is: "YES",
            },
            fields: [
              {
                label: "Uploaded Job Contractor Agreement/Contract Document",
                labelHidden: true,
                machine_name: "empIsContractAttached",
                name: "Job Contractor Agreement/Contract",
                widget: "file_upload",
                choice: "Yes",
                value: "YES",
                fileTypes: [".pdf", ".doc", ".docx", ".txt", ".xls", ".xlsx"],
                validate: ["required", "checkValue"],
              },
            ],
          },
        },
      ],
    },
    {
      name: "Foreign Labor Recruiter Information",
      fields: [
        {
          isGroup: {
            code: "G.5",
            machine_name: "empflrecEngageH2b",
            label: `Is the employer, and its attorney or agent, as applicable, engaging or planning to engage any agent(s) 
            or recruiter(s) in the recruitment of prospective H-2B workers, regardless of whether such agent(s) or 
            recruiter(s) is (are) located in the U.S. or abroad? *`,
            tooltip: `Check “Yes” or “No” to indicate if the employer and its attorney or agent (as applicable) are engaging 
            or plan to engage any agents or recruiters to recruit H-2B workers, regardless if the agent(s) or recruiter(s) 
            is (are) located in the U.S. or abroad.`,
            coloring: "none",
            type: "radio",
            // if g5 is YES set empflrecApdxCAttached to YES
            // if g5 is NO set empflrecApdxCAttached to N/A
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                validate: ["required"],
                setSchema: [
                  {
                    set: "empflrecApdxCAttached",
                    to: "YES",
                  },
                ],
              },
              {
                widget: "radio",
                choice: "No",
                value: "NO",
                validate: ["required"],
                setSchema: [
                  {
                    set: "empflrecApdxCAttached",
                    to: "N/A",
                  },
                ],
                clearSchema: ["recruiters"],
                clearFiles: ["empflrecEngageH2bAttached"],
              },
            ],
          },
        },
        {
          isGroup: {
            code: "G.6",
            machine_name: "empflrecEngageH2bAttached",
            label: `You must upload a copy of all agreements with any agent or recruiter whom you are engaging or planning to engage in the recruitment of H-2B Workers.`,
            tooltip: `An employer is required under 20 CFR 655.9 to submit a copy of all agreements with any agent or recruiter whom it engages or plans to engage in the recruitment of H-2B workers. 
            This requirement includes agreements that the employer itself has entered into and agreements the employer’s agent or attorney has entered into with such entities. 
            Check the appropriate box to indicate whether a copy of all required agreements is attached to the application.`,
            coloring: "none",
            name: "Document Upload - Recruiter Agreement",
            fields: [
              {
                label: "Uploaded Recruiter Agreement Document",
                labelHidden: true,
                machine_name: "empflrecEngageH2bAttached",
                name: "Recruiter Agreement",
                widget: "file_upload",
                choice: "Yes",
                value: "YES",
                fileTypes: [".pdf", ".doc", ".docx", ".txt", ".xls", ".xlsx"],
                validate: ["required", "checkValue"],
              },
            ],
            isVisible: {
              when: "empflrecEngageH2b",
              is: "YES",
            },
          },
        },
        {
          machine_name: "empflrecApdxCAttached",
          widget: "text",
          hidden: true,
          disabled: true,
          label: "Is Appendix C Attached?",
          code: "G.7",
        },
      ],
    },
    {
      name: "Document Upload - Appendix B",
      fields: [
        {
          isGroup: {
            code: "H.1",
            machine_name: "declareIsConfmApdxB",
            label: `Confirm that you have read and agree to all the applicable terms, assurances and obligations contained 
            in Appendix B <u>and</u> attach a signed and dated copy of 
            <a href="https://flag.dol.gov/sites/default/files/2023-08/Form%20ETA-9142B_AppendixB.pdf" rel="noopener noreferrer" target="_blank">Appendix B</a>.`,
            tooltip: `Check the appropriate box to indicate if the employer and its attorney or agent (as applicable) 
            have read and agree to all the terms, assurances, and obligations contained in the Appendix B (Declarations by 
            the Employer and Attorney or Agent) and have attached a signed and dated copy of Appendix B to this application.`,
            coloring: "none",
            fields: [
              {
                label: "Uploaded Appendix B Document",
                labelHidden: true,
                machine_name: "declareIsConfmApdxB",
                name: "Appendix B",
                widget: "file_upload",
                choice: "Yes",
                value: "YES",
                fileTypes: [".pdf", ".doc", ".docx", ".txt", ".xls", ".xlsx"],
                validate: ["required", "checkValue"],
              },
            ],
          },
        },
      ],
    },
    {
      name: "Document Upload - Employer-client Appendix B",
      fields: [
        {
          isGroup: {
            code: "H.2",
            machine_name: "declareConfmEmp",
            label: `Because this application relates to Joint Employer, confirm that the joint employer (or employer-client 
            for a job contractor) identified in Appendix D has read and agrees to all the applicable terms, assurances, and 
            obligations contained in Appendix B and has attached a separate signed and dated copy of 
            <a href='https://flag.dol.gov/sites/default/files/2023-08/Form%20ETA-9142B_AppendixB.pdf' rel='noopener noreferrer' target='_blank'>Appendix B</a> 
            with this application.`,
            tooltip: `If this application is submitted by a joint employer or a job contractor, check the appropriate box to indicate whether 
            or not the joint employer or employer-client identified in Appendix D (see questions in Sections G.3 and G.4) has read 
            and agrees to all the terms, assurances, and obligations contained in Appendix B (Declarations by the Employer 
              and Attorney or Agent) and has attached a signed and dated copy of Appendix B to this application.`,
            coloring: "none",
            fields: [
              {
                label: "Uploaded Employer-client Appendix B Document",
                labelHidden: true,
                machine_name: "declareConfmEmp",
                name: "Employer-client Appendix B",
                widget: "file_upload",
                choice: "Yes",
                value: "YES",
                fileTypes: [".pdf", ".doc", ".docx", ".txt", ".xls", ".xlsx"],
                validate: ["required", "checkValue"],
              },
            ],
          },
        },
      ],
      isVisible: {
        when: "empType",
        is: "Joint Employer (e.g., Job Contractor)",
      },
    },
  ],
};
